import {
    TabComponent,
    TabItemDirective,
    TabItemsDirective,
} from '@syncfusion/ej2-react-navigations';
import './lladmin.scss';
import LocationSettings from './locationsettings/locationsettings';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setRowData } from '../grid/gridReducer';
import {
    setSelectedRecrdsExport,
    setTabNameForRowData,
} from '../contactTabs/contactReducer';
import { getLlAdminEndPoint } from './utils';
import axios from 'axios';
import {
    setClientsData,
    setIsLoaderShow,
    setLanguageData,
    setMsgMgmtData,
} from './lladminreducer';
import ClientIdManagament from './clientidmanagement/clientIdMgmt';
import notify from '../../services/toasterService';
import CompanyComponent from './comany-codes/company-codes';
import AdminUserManagement from './admin-users/admin-users';
import UserManagement from '../accessMgmt/usermanagement/usermanagement';
import { getAccessMgmtEndPoint } from '../accessMgmt/utils';
import {
    setRolesData,
    setRolesList,
    setUserAccessData,
} from '../accessMgmt/accessmgmtReducer';

const parentTab = [
    { text: 'Company Codes', id: '0' },
    { text: 'Admin Users', id: '1' },
    { text: 'Client ID Management', id: '2' },
    { text: 'Location Settings', id: '3' },

    // { text: "Message Management" },
];

const LlAdmin = () => {
    const dispatch = useDispatch();
    let selectedTab: string;

    useEffect(() => {
        dispatch(setRowData([]));
        dispatch(setSelectedRecrdsExport([]));
        dispatch(setTabNameForRowData(''));
    });

    const TabChangeEvent = async (e: any) => {
        dispatch(setRowData([]));
        selectedTab = e.selectingItem.innerText;

        if (selectedTab !== 'Location Settings') {
            if (selectedTab === 'Admin Users') {
                getAccessManagementTab(selectedTab);
            } else {
                await LlAdminTabApi(e.selectingItem.innerText);
            }
        }
    };

    const getTabEvent = (e: any) => {
        // console.log(e, 'On page load Tab');
        if (e !== null) {
            const selectedId = e.selectingID;
            console.log(selectedId);
            //   childTab.map((item) => {
            //     if (item.id === selectedId) {
            //       selectedTab = item.text;
            //       locationSettingTabApi(selectedTab);
            //     }
            //   });
            // console.log(selectedTab, 'selectedTab');
        }
    };

    /**
     * LL Admin Tab Change event
     * @author Anudeep
     * @param TabName - Selected Tab name
     */
    const LlAdminTabApi = async (TabName: any) => {
        dispatch(setIsLoaderShow(true));
        const endPointURL = getLlAdminEndPoint(TabName);
        await axios
            .get(endPointURL)
            .then((res) => {
                dispatch(setIsLoaderShow(false));
                if (TabName === 'Client ID Management') {
                    dispatch(setClientsData(res.data));
                } else if (TabName === 'Message Management') {
                    dispatch(setMsgMgmtData(res.data));
                    const endPointURL = getLlAdminEndPoint('Languages');
                    axios
                        .get(endPointURL)
                        .then((res) => {
                            dispatch(setLanguageData(res.data));
                        })
                        .catch((err) => {
                            dispatch(setIsLoaderShow(false));
                            notify(err, 'error');
                        });
                }
            })
            .catch((err) => {
                notify('Failed to fetch data', 'error');
                dispatch(setIsLoaderShow(false));
            });
    };

    const getAccessManagementTab = async (TabName: any) => {
        dispatch(setIsLoaderShow(true));
        // const token = UserService.getToken();
        // console.log(token);
        // const token = sessionStorage.getItem('token');
        const endPointURL = getAccessMgmtEndPoint('Users');

        // await axios.get(endPointURL, { headers: { 'Authorization': `Bearer ${token}` } }).then((res: any) => {
        await axios
            .get(endPointURL)
            .then((res: any) => {
                res.data.forEach((element: any) => {
                    element.companyName =
                        element.userCompanyMapping?.length > 0
                            ? element.userCompanyMapping[0]?.company
                                  ?.companyName
                            : '';
                    if (element.userCompanyMapping?.length > 0) {
                        element.roleID =
                            element.userCompanyMapping[0]?.roleId[0] || '';
                    }
                });
                dispatch(setIsLoaderShow(false));
                dispatch(setUserAccessData(res.data));
                getRoles('Roles');
            })
            .catch((err) => {
                console.log(err);
                notify(
                    'Error! Unable to fetch data. Please try after sometime.',
                    'error'
                );
                dispatch(setIsLoaderShow(false));
            });
    };

    const getRoles = async (fieldName: any) => {
        dispatch(setIsLoaderShow(true));
        // const token = sessionStorage.getItem('token');
        // const token = UserService.getToken();
        const getEndPointUrl = getAccessMgmtEndPoint(fieldName);
        // await axios.post(getEndPointUrl, {}, { headers: { 'Authorization': `Bearer ${token}` } }).then((res: { data: any; }) => {
        await axios
            .post(getEndPointUrl, {})
            .then((res: { data: any }) => {
                dispatch(setIsLoaderShow(false));
                dispatch(setRolesData(res.data));
                dispatch(setRolesList(res.data));
            })
            .catch((err: any) => {
                dispatch(setIsLoaderShow(false));
                console.log(err);
                notify(
                    'Error! Unable to fetch data. Please try after sometime.',
                    'error'
                );
            });
    };

    return (
        <div className="col-sm-12 col-md-12 col-lg-12 parent-tab-width">
            <div className="control-pane">
                <div className="control-section tab-control-section">
                    <TabComponent
                        heightAdjustMode="Auto"
                        cssClass="orientation-tab ll-custom-tab"
                        selecting={TabChangeEvent}
                        // selected={getSelectedTabEvent}
                        ref={(tab) => getTabEvent(tab)}
                    >
                        <TabItemsDirective>
                            <TabItemDirective
                                header={parentTab[0]}
                                content={companyCodes}
                            />

                            <TabItemDirective
                                header={parentTab[1]}
                                content={UserManagement}
                            />

                            <TabItemDirective
                                header={parentTab[2]}
                                content={clientIdManagement}
                            />
                            <TabItemDirective
                                header={parentTab[3]}
                                content={locationSettings}
                            />
                        </TabItemsDirective>
                    </TabComponent>
                </div>
            </div>
        </div>
    );

    function companyCodes() {
        return (
            <div>
                <div className="col-sm-12 col-md-12 col-lg-12 ">
                    <CompanyComponent />
                </div>
            </div>
        );
    }

    function adminUsers() {
        return (
            <div>
                <div className="col-sm-12 col-md-12 col-lg-12 ">
                    <AdminUserManagement />
                </div>
            </div>
        );
    }

    function locationSettings() {
        return (
            <div>
                <div className="col-sm-12 col-md-12 col-lg-12 ">
                    <LocationSettings />
                </div>
            </div>
        );
    }

    function clientIdManagement() {
        return (
            <div>
                <div className="col-sm-12 col-md-12 col-lg-12 pt-2">
                    <ClientIdManagament />
                </div>
            </div>
        );
    }

    // function messageManagement() {
    //     return (
    //         <div>
    //             <div className="col-sm-12 col-md-12 col-lg-12 pt-2">
    //                 <MessageManagement />
    //             </div>
    //         </div>
    //     );
    // }
};

export default LlAdmin;
